module.exports = __webpack_public_path__ + "media/images/builder/majaslapa-a125cc76694dc979af515cf441288903.png";